<div>
    <div class="buttons" fxLayout="row wrap" fxLayoutAlign="end center" fxLayoutAlign.lt-sm="start center">
        <ng-content></ng-content>
    </div>
</div>
